<!-- 专题管理编辑页 -->
<template>
  <div class="page-module-wrap">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="section-gap">
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">标题：</label>
                <div class="inline-block">
                  <input class="input width-2" type="text" v-model="params.title">
                </div>
              </div>
            </div>
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">显示状态：</label>
                <div class="inline-block">
                  <span class="radio r-top">
                    <input type="radio" name="shopProp" value="1" v-model="status" >
                    <label for="good">永久开启</label>
                  </span>
                  <span class="radio r-top">
                    <input type="radio" name="shopProp" value="0" v-model="status" >
                    <label for="suit">永久关闭</label>
                  </span>
                  <span class="radio r-top">
                    <input type="radio" name="shopProp" value="2" v-model="status" >
                    <label for="suit">定时开关</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="block" v-if="status === 2 || status === '2'">
              <div class="control">
                <el-date-picker v-model="params.timeRange" type="datetimerange" placeholder="选择时间范围"></el-date-picker>
              </div>
            </div>

            <p class="title">自定义链接</p>
            <div class="block cyzs-w-400">
              <custom-link :link='params.ext.link' @update:link="val => { params.ext.link = val }"></custom-link>
            </div>

            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">封面图：</label>
                <div class="block">
                  <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
                  <span class="picText">建议尺寸：686*340px</span><span style="margin-left: 20px; line-height 32px;">只能上传 jpg/png 文件，且不超过1MB</span>
                </div>
                <div class="block">
                  <image-component :image='params.ext.image.image' :width="600"></image-component>
                </div>
              </div>
            </div>
            <div class="inline-block">
              <p>
                <span class="button is-danger" @click="onSave">保存</span>
                <span class="button is-info" @click="backClick">返回</span>
              </p>
            </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import { formatDate } from 'UTILS/date'
import CustomLink from 'COMMON/DefinedLink'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    CustomLink
  },
  data () {
    return {
      status: 0,
      type: '',
      params: {
        ext: {
          image: {
            image: '',
            width: 0,
            height: 0
          },
          link: ''
        },
        title: '',
        status: '',
        timeRange: []
      },
      contentId: ''
    }
  },
  computed: {
    ...mapState({
      currentFashionMenu: state => state.currentFashionMenu
    })
  },
  mounted () {
    if (this.currentFashionMenu.moduleType == -1) {
      this.setCurrentFashionMenuByVuex({
        type: this.$route.query.type,
        moduleType: this.$route.query.moduleType,
        moduleId: this.$route.query.moduleId
      })
    }
    this.type = this.$route.query.operationType
    this.uploadMainBind()
    this.contentId = this.$route.query.contentId && this.$route.query.contentId || ''
    if (this.type === 'edit') {
      this.getInitial()
    }
  },
  methods: {
    ...mapActions([
      'setCurrentFashionMenuByVuex'
    ]),
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.ext.image.image = response.data.images.info.path
            this.params.ext.image.width = response.data.images.info.width
            this.params.ext.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    getInitial () {
      let params = {
        contentId: this.contentId
      }
      HttpRequest.get('/admin.php?method=fashion.getModuleContent', params, true).then(response => {
        if (response && response.result === 0) {
          this.params = Object.assign(this.params, response.data)
          this.status = response.data.status
          if (response.data.status === 1 && response.data.startTime > 0 && response.data.endTime > 0) {
            this.status = '2'
          }
          this.params.timeRange = []
          this.params.timeRange.push(formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss'))
          this.params.timeRange.push(formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss'))
        }
      })
    },

    /**
       * 保存
       * 提交
       */
    onSave () {
      this.params.status = this.status * 1
      let params = Object.assign({}, this.params)

      if (parseInt(this.status) !== 2) {
        params.startTime = 0
        params.endTime = 0
      } else {
        params.startTime = this.params.timeRange[0]
        params.endTime = this.params.timeRange[1]
      }
      if (parseInt(this.status) === 2) {
        params.status = 1
      }
      params.type = 0
      params.contentId = this.contentId
      params.moduleId = this.currentFashionMenu.moduleId
      params.moduleType = 2
      params.ext = JSON.stringify(params.ext)

      HttpRequest.post('/admin.php?method=fashion.doSaveModuleContent', params, true).then(response => {
        if (response.data.success == 1) {
          this.$message('保存成功')
          setTimeout(() => {
            if (this.currentFashionMenu.type == 0) {
              this.$router.push({
                name: 'market',
                query: {
                  page: this.$route.query.page
                }
              })
            } else if (this.currentFashionMenu.type == 1) {
              this.$router.push({
                name: 'discovery',
                query: {
                  page: this.$route.query.page
                }
              })
            }
          }, 2000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      })
    },
    backClick () {
      this.$router.push({
        name: 'market',
        query: {
          page: this.$route.query.page
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .page-module-wrap{
    .module-menu {
      width: 200px;
      min-width: 200px;
      margin-right: 20px;
    }
    td{
      span{
        word-break: break-all;
      }
    }
    p{
      word-break: break-all;
    }
    .clearfix:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .clearfix {
      _overflow: hidden;
    }
    .fleft{
      float: left;
    }
    .fright{
      float: right;
    }
    .red{
      color:red;
    }
    .green{
      color:green;
    }
    .margin-top {
      margin-top: 10px;
    }
    .margin-left {
      margin-left: 40px;
    }
    .width-2 {
      width: 150px;
    }
    .width-3{
      width: 200px;
      input{
        width:180px;
      }
    }
    .inline-block {
      display: inline-block;
    }
    .vertical-middle {
      vertical-align: middle;
    }

    .title {
      font-size: 16px;
      height: 25px;
      line-height: 16px;
      padding-left: 6px;
      padding-right: 6px;
      font-weight: bold;
    }

    .control {
      display: inline-block;
      margin-right: 20px;
    }
    .margin-left1{
      margin-left: 20px;
    }
    .r-top {
      position: relative;
      top: 5px;
    }
    .danger{
      background-color: #ed6c63;
      border-color: transparent;
      color: white;
    }

    .section-gap{
      border-bottom: 1px dashed #666;
      padding-bottom: 15px;
      margin-bottom: 20px;
    }
    .list-wrap{
      padding-bottom: 40px;
      .order-item{
        margin-bottom: 30px;
        .img-goods{
          width:90%;
        }
      }
      .goods-img {
        min-width: 70px;
      }
    }
    .data-isnull {
      display: inline-block;
      width: 100%;
      font-size: 25px;
      color:#ccc;
      text-align: center;
    }
    .custom-link-wrap{
      border-radius: 6px;
      border: 1px solid #00d1b2;
      width: 300px;
      padding: 20px;
    }
    .picText {
      color: #ff0000;
      margin-left: 20px;
      line-height: 32px;
    }
  }
</style>
